<template>
  <div id="SkeletonPetCards">

  <div class="all-owned-pets">

    <!-- <div class="skeleton-info-area" v-for="(pet, idx) in pets" :key="idx">
      <div class="skeleton-banner" ></div>
      <div class="skeleton-image" >  </div>

      <div class="skeleton-details">
        <div class="skeleton-text-1">.</div>
        <div class="skeleton-text-1">.</div>
        <div class="skeleton-details-bio">
          <span class="skeleton-text-3"></span>
          <span class="skeleton-text-3"></span>
        </div>

        <div class="personalities-bar">
          <div class="skeleton-pod">.</div>
          <div class="skeleton-pod">.</div>
          <div class="skeleton-pod">.</div>
          <div class="skeleton-pod">.</div>
          <div class="skeleton-pod">.</div>
        </div>

      </div>
    </div> -->
    <img src="@/assets/gfx/loader.png" />
    <img src="@/assets/gfx/loader.png" />
    <img src="@/assets/gfx/loader.png" />
  </div>
  </div>
</template>

<script>

export default {
  name: 'SkeletonPetCards',
  data(){
    return{
      pets_owned: [],
      pets:['', '', ''],
    }
  },
}
</script>
<style scoped>
#SkeletonPetCards{
  margin: auto;
  padding: 1rem;
  max-width: 900px;
}
.all-owned-pets{
  width: 100%;
  margin: auto;
  text-align:center;
  display: flex;
  flex-direction: column;
}
.all-owned-pets img{
  margin: 1rem auto;
  border-radius: 20px;
  width: 90%;
  /* width: 300px; */
  transition: 1s;
  -webkit-box-shadow: 14px 12px 52px -22px rgba(110,110,110,1);
  -moz-box-shadow: 14px 12px 52px -22px rgba(110,110,110,1);
  box-shadow: 14px 12px 52px -22px rgba(110,110,110,1);
}
.skeleton-info-area{
  text-align:center;
  min-height: 18rem;
  width: 98%;
  /* border: 2px solid #888; */
  border-radius: 35px;
  margin: 1rem auto;
  color: var(--primary);
  position: relative;
  transition: 1s;
  -webkit-box-shadow: 14px 12px 52px -22px rgba(110,110,110,1);
  -moz-box-shadow: 14px 12px 52px -22px rgba(110,110,110,1);
  box-shadow: 14px 12px 52px -22px rgba(110,110,110,1);
}
.skeleton-banner{
  width: 100%;
  height: 10rem;
  border-radius: 25px 25px 0  0;
  background-color: #C1C1C1;
  transition: 1s;
}
/*----------------------*\
|     PROFILE IMAGE
\*----------------------*/
.skeleton-image{
  width: 9rem;
  height: 9rem;
  border-radius: 100%;
  overflow:hidden;
  position: absolute;
  top: 2rem;
  left: 1rem;
  z-index: 10;
  border: 5px solid var(--bg-default);
  background-color: #C1C1C1;
}
/*----------------------*\
|  PROFILE IMAGE END
\*----------------------*/
.skeleton-details{
  width: 100%;
  height: 100%;
  margin-top: 2rem;
  padding-left: 3rem;
  text-align: left;
  transition: 1rem;
}
.skeleton-text-1{
  background-color: #d0d0d0;
  color: #d0d0d0;
  width: 50%;
  border-radius: 20px;
  padding: .1rem;
  margin: .3rem;
}


.personalities-bar{
  display:flex;
  width: 90%;
  flex-direction: row;
  overflow-x: scroll;
}

.personalities-bar::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}
.skeleton-pod{
  background-color: #d0d0d0;
  padding: .1rem;
  margin: .3rem;
  width: 4rem;
  border-radius: 10px;
}


@media only screen and (max-width: 600px) {
  .skeleton-info-area{min-height: 13rem}
  .all-owned-pets img{ width: 300px;height: 200px;}
  .skeleton-image{
    width: 5rem;
    height: 5rem;
    top: 3rem;
    border: 2px solid var(--bg-default);
  }
  .trait-pod{
    padding: .3rem;
    font-size: .6rem;
    margin: auto .2rem;
  }
  .skeleton-details{
    margin-top: 1.4rem;
    padding-left: 1.5rem;
  }
  .skeleton-details h2{font-size: 1.2rem;}
  .skeleton-details-bio{
    border-left: 3px solid var(--primary);
    padding-left: .3rem;
    margin: 1rem .7rem;
  }
  .skeleton-details-bio p{font-size: .6rem; margin: .3rem;}
  .skeleton-details h4{font-size:  .8rem; margin: .2rem auto;}

}
@media only screen and (max-width: 400px) {
  #SkeletonPetCards{
    padding: .3rem;
  }
  .skeleton-banner{
    height: 8rem;
  }
  .skeleton-info-area{
    min-height: 15rem;
  }
}
</style>
